import { ReactNode, useEffect, useState } from "react";
import { CardItem } from "./Card";
import { Carousel } from "react-bootstrap";
import CardGroup from "./CardGroup";
import CardSplice from "../../helpers/CardSplice";
import './CardGroupSlider.css';
import { CardBody } from "./CardBody";

type Props = {
    id: string;
    cards: Array<CardItem>;
    columns: number;
    interval?: number;
    indicators?: boolean;
    cardBody: (card: CardItem) => ReactNode;
}

export default function CardGroupSlider(props: Props) {
    const {cards, columns, interval = undefined, indicators = true} = props;
    const [index, setIndex] = useState<number>(0);
    const [cardColumns, setCardColumns] = useState<Array<CardItem[]|never>>([]);

    useEffect(() => {
        if (columns > 0) {
            setCardColumns(CardSplice(cards, columns));
        }
    }, [cards, columns, setCardColumns]);
  
    const handleSelect = (selectedIndex: number) => {
      setIndex(selectedIndex);
    };

    return cards.length ? (
        <Carousel
            id={props.id}
            className={`carousel-card-groups`}
            interval={interval}
            activeIndex={index}
            onSelect={handleSelect}
            indicators={cardColumns.length ? indicators : false}
            prevIcon={
                cardColumns.length ? <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.7611 27.1772L33.6474 38.7143C35.3358 39.6938 37.4999 38.5091 37.4999 36.5384V13.4642C37.4999 11.4934 35.3358 10.3087 33.6474 11.2882L13.7611 22.8253C12.0795 23.8009 12.0795 26.2017 13.7611 27.1772Z" fill="#232323"/>
                </svg> : <></>
            }
            nextIcon={
                cardColumns.length ? <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M36.2388 27.177L16.3525 38.7141C14.6641 39.6936 12.5 38.5088 12.5 36.5381V13.4639C12.5 11.4932 14.6641 10.3085 16.3525 11.288L36.2388 22.8251C37.9204 23.8006 37.9204 26.2014 36.2388 27.177Z" fill="#232323"/>
                </svg> : <></>
            }
        >
            {cardColumns.length ? cardColumns.map((cardColumn: Array<CardItem>, index: number) => {
                return <Carousel.Item
                    key={index}
                    interval={interval ? interval : interval}
                >
                    <CardGroup id={`${props.id}_${index}`} cards={cardColumn} cardBody={CardBody} />
                </Carousel.Item>
            }) : <></>}
        </Carousel>
    ) : <div className="text-center py-4">Nessuna card da visualizzare</div>
}